<template lang="pug">

section.src-components-cambia-fp
  v-dialog(v-model='dialog' max-width='500px')
    v-card
      v-card-title
        span.text-h5 Modificar Medio de pago
      v-card-text
        span Actual: {{venta.pagoL2t}}
        v-container
          .d-flex.justify-center.flex-wrap
            v-btn(v-for="(item,index) of medios" :key="index" color="primary"
            @click="$emit('cambiamp',item)").ma-1 {{item.descripcion}}
      v-card-actions
        v-spacer
        v-btn(color='blue darken-1' text='' @click="$emit('close')") Cancela
        v-btn(color='blue darken-1' text='' @click="$emit('partido')") Varios Pagos

</template>

<script lang="js">

  export default  {
    name: 'src-components-cambia-fp',
    props: ['venta','dialog','medios'],
    mounted () {

    },
    data () {
      return {

      }
    },
    methods: {


    },
    computed: {

    }
}


</script>

<style scoped lang="scss">
  .src-components-cambia-fp {

  }
</style>
